
export default {
  name: "blogPost",
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
